import React from 'react';
import './VenueAnalysisNavigation.scss';
import { VenueAnalysisData } from '../venueAnalysisAggregatedData';
import classNames from 'classnames';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import {
    isVenueSelected,
    VenueAnalysisSelection,
} from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';

interface VenueAnalysisNavigationProps {
    data?: VenueAnalysisData;
    selection?: VenueAnalysisSelection;
    onChangeSelection: (selection?: VenueAnalysisSelection) => void;
}

export function VenueAnalysisNavigation({
    data,
    selection,
    onChangeSelection,
}: VenueAnalysisNavigationProps) {
    const selectedType = !!selection;
    const selectedVenue = isVenueSelected(selection);
    const selectedTypeActive = selectedType && !selectedVenue;

    const onCloseClicked = () => {
        if (selectedVenue) {
            onChangeSelection({ venueTypeName: selection!.venueTypeName });
        } else {
            onChangeSelection(undefined);
        }
    };

    const onTypeClick = () => {
        onChangeSelection({ venueTypeName: selection!.venueTypeName });
    };

    const classes = classNames(
        'VenueAnalysisNavigation',
        selectedType && 'selected-type',
        selectedVenue && 'selected-venue'
    );

    return (
        <div className={classes}>
            <div className={'widget-title'}>
                {data?.orderInfo?.symbolDescription}
            </div>
            {selectedType && (
                <div className="venue-analysis-navigation">
                    <div
                        className="clear-selection"
                        onClick={() => onChangeSelection(undefined)}
                    >
                        All Venues
                        <Icon name="angle right" />
                    </div>
                    <div className="selected-type" onClick={onTypeClick}>
                        <div
                            className={
                                selectedTypeActive ? 'active-selection' : ''
                            }
                        >
                            {selection?.venueTypeName}
                        </div>
                    </div>
                    {isVenueSelected(selection) && (
                        <>
                            <Icon name="angle right" />
                            <div className="selected-venue">
                                <div
                                    className={
                                        selectedVenue ? 'active-selection' : ''
                                    }
                                >
                                    {selection?.venueName}
                                </div>
                            </div>
                        </>
                    )}
                    <Icon name="close" onClick={onCloseClicked} />
                </div>
            )}
        </div>
    );
}
